import styled from "styled-components";
import { cssTemplate, media, typographyV2 } from "../../../../constants/styles";
import Responsable from "../../../Responsable";
import BaseSection from "../../BaseSection";
import { useIntersecting } from "../../../../hooks/useIntersecting";
import { useEffect, useState } from "react";
import ValueUpCardList from "../scrollOverays/ScrollOverlayValueUpService/ValueUpCardList";

const Estimate_solid = () => {
  const { ref, isIntersecting } = useIntersecting();
  const [isInteracted, setIsInteracted] = useState(false);

  useEffect(() => {
    if (isIntersecting) setIsInteracted(true);
  }, [isIntersecting]);

  return (
    <BaseSection fullWidth>
      <Container ref={ref} theme={{ isIntersecting: isInteracted }}>
        <Responsable
          widthFull
          pc={
            <>
              <Section>
                <h3>Valueup Service</h3>
                <h2>
                  밸류업 사업부는 특정 분야에 강한 회사와 조인트벤처를
                  <br />
                  설립해 세상에 가치있는 서비스를 만들어 갑니다
                </h2>
                <ValueUpCardList screenType={"PC"} />
              </Section>
            </>
          }
          tablet={
            <>
              <Section>
                <h3>Valueup Service</h3>
                <h2>
                  밸류업 사업부는 특정 분야에 강한
                  <br />
                  회사와 조인트벤처를 설립해 세상에
                  <br />
                  가치있는 서비스를 만들어 갑니다
                </h2>
                <ValueUpCardList screenType={"TABLET"} />
              </Section>
            </>
          }
          mobile={
            <>
              <Section>
                <h3>Valueup Service</h3>
                <h2>
                  밸류업 사업부는
                  <br />
                  특정 분야에 강한 회사와
                  <br />
                  조인트벤처를 설립해
                  <br />
                  세상에 가치있는 서비스를
                  <br />
                  만들어 갑니다
                </h2>
                <ValueUpCardList screenType={"MOBILE"} />
              </Section>
            </>
          }
        />
      </Container>
    </BaseSection>
  );
};
export default Estimate_solid;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${(props) => cssTemplate.fadeInOut(props)};
  max-width: 1296px;
  width: 100%;
  margin: 0 auto;
  gap: 100px;
  padding: 160px 48px;

  ${media.TABLET} {
    padding: 140px 48px;
  }

  ${media.MOBILE} {
    gap: 60px;
    padding: 80px 24px;
  }
`;

const Section = styled.section`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  word-break: keep-all;
  width: 100%;

  h2 {
    ${typographyV2.HEADING_1_B};
  }

  h3 {
    ${typographyV2.BODY_2_M};
  }

  ${media.TABLET} {
  }
  ${media.MOBILE} {
    h2 {
      ${typographyV2.HEADING_3_B};
    }

    h3 {
      ${typographyV2.BODY_4_M};
    }
  }
`;
